import { schema } from "normalizr";

export default new schema.Entity(
  "notificationEvents",
  {},
  {
    idAttribute: "id",
  }
);
